export const ENROLLMENT = '/enrollment-list'
export const ENROLLMENT_PAGE = '/enrollment'
